import classNames from 'classnames'
import { useHistory } from 'react-router'

import Icon from 'shared/components/Icon'
import Button from 'shared/components/Button'

import { reservationsSelector, reservationIdSelector } from 'extending/selectors'
import { setReservations } from 'dashboard-transactions/actions'

import styles from '../styles.module.scss'

const BookingCancelledPage = ({ reservations, reservationId, setReservations }) => {
    const history = useHistory()

    const locationId = reservations[reservationId]?.locationId

    React.useEffect(() => {
        setReservations([])

        if (!locationId) {
            history.push('/manage-my-booking')
        }
    }, [])

    return (
        <section className={styles.findBookingContainer}>
            <Icon type="check-circle" size="xl" />
            <h2 className="mt-6">
                <T>manage.my.booking.cancelled.page.heading</T>
            </h2>
            <p className="mt-4 font-weight-bold text-large">
                <T>manage.my.booking.cancelled.time.details</T>
            </p>
            <p className="mt-4 text-large">
                <T>manage.my.booking.cancelled.message</T>
            </p>
            <Button
                btnStyle="primary"
                block
                className={classNames('mt-6', 'mx-auto', styles.bookAgainBtn)}
                href={`/booking/${locationId}`}>
                <T>manage.my.booking.cancelled.book.again.btn</T>
            </Button>
        </section>
    )
}
export default compose(
    connect(
        createStructuredSelector({
            reservations: reservationsSelector,
            reservationId: reservationIdSelector,
        }),
        { setReservations }
    )
)(BookingCancelledPage)
